import React from 'react';
import { Fab } from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export function DiscussionFAB(props) {
    const fabStyle = { margin: 0, top: 'auto', right: 250, bottom: 60, left: 'auto', position: 'fixed' };
    let { message, onClick } = props;
    if (!message) return <div />
    return (
        <div style={{ position: 'absolute', zIndex: 99 }}>
            <Fab className="material-button" variant="extended" style={fabStyle} onClick={onClick}>
                <FontAwesomeIcon icon={[`far`, "mouse-pointer"]} style={{ marginRight: '5px' }} />
                {props.message}
            </Fab>
        </div>
    );
}
